import { createSlice } from "@reduxjs/toolkit";
import { filterDocumentObject, generateNewDocumentObject, restoreDocumentObject, updateDocumentObject } from '../helpers/app';

const initialState: initialStateDocumentsProps = {
    types: {
        fetching: "unknown",
        data: []
    },
    fetchingDocuments: "unknown",
    documents: {
        identity_card: [],
        salary_settlements: [],
        previred_certificate: [],
        domicile_certificate: [],
        bank_data: [],
        references: []
    },
    valid: {
        fetching: "unknown",
        data: [],
        error: "",
        signers: {
            fetching: "unknown",
            data: [],
            error: ""
        }
    },
    fetchingPostDocuments: "unknown",
    fetchingPostDocumentImage: "unknown",
    fetchingDeleteDocument: "unknown",
    fetchingDeleteDocumentImage: "unknown",
    signers: {
        fetching: "unknown",
        data: [],
        error: "",
        count: 0,
        post: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        put: {
            fetching: "unknown",
            data: [],
            error: ""
        },
        bankData: {
            fetching: "unknown",
            data: [],
            error: ""
        }
    }
}


const documentsSlice = createSlice({
    name: "documents",
    initialState,
    reducers: {
        setDocuments: (state, action) => {
            state.documents = generateNewDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        getDocumentsTypesRequest: (state) => {
            state.types.fetching = "loading";
        },
        getDocumentsTypesSuccess: (state, action) => {
            state.types.fetching = "success";
            state.types.data = action.payload.documents;
        },
        getDocumentsTypesFailure: (state) => {
            state.types.fetching = "failure";
        },
        cleanGetDocumentsTypes: (state) => {
            state.types.fetching = initialState.types.fetching;
        },
        getDocumentsRequest: (state) => {
            state.fetchingDocuments = "loading";
        },
        getDocumentsSuccess: (state, action) => {
            state.fetchingDocuments = "success";
            state.documents = generateNewDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        getDocumentsFailure: (state) => {
            state.fetchingDocuments = "failure";
        },
        cleanGetDocuments: (state) => {
            state.fetchingDocuments = initialState.fetchingDocuments;
        },
        postDocumentImageRequest: (state) => {
            state.fetchingPostDocumentImage = "loading";
        },
        postDocumentImageSuccess: (state, action) => {
            state.fetchingPostDocumentImage = "success";
            state.documents = generateNewDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        postDocumentImageFailure: (state, action) => {
            state.fetchingPostDocumentImage = "failure";
            state.documents = generateNewDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        cleanPostDocumentImage: (state) => {
            state.fetchingPostDocumentImage = initialState.fetchingPostDocumentImage;
        },
        postDocumentsRequest: (state) => {
            state.fetchingPostDocuments = "loading";
        },
        postDocumentsSuccess: (state, action) => {
            state.fetchingPostDocuments = "success";
            state.documents = generateNewDocumentObject(action.payload.type, state.documents, action.payload.data)
        },
        postDocumentsFailure: (state) => {
            state.fetchingPostDocuments = "failure";
        },
        cleanPostDocuments: (state) => {
            state.fetchingPostDocuments = initialState.fetchingPostDocuments;
        },
        deleteDocumentImageRequest: (state) => {
            state.fetchingDeleteDocumentImage = "loading";
        },
        deleteDocumentImageSuccess: (state, action) => {
            state.fetchingDeleteDocumentImage = "success";
            state.documents = filterDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        deleteDocumentImageFailure: (state, action) => {
            state.fetchingDeleteDocumentImage = "failure";
            state.documents = restoreDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        cleanDeleteDocumentImage: (state) => {
            state.fetchingDeleteDocumentImage = initialState.fetchingDeleteDocumentImage;
        },
        deleteDocumentRequest: (state) => {
            state.fetchingDeleteDocument = "loading";
        },
        deleteDocumentSuccess: (state, action) => {
            state.fetchingDeleteDocument = "success";
            state.documents = filterDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        deleteDocumentFailure: (state, action) => {
            state.fetchingDeleteDocument = "failure";
            state.documents = restoreDocumentObject(action.payload.type, state.documents, action.payload.data);
        },
        cleanDeleteDocument: (state) => {
            state.fetchingDeleteDocument = initialState.fetchingDeleteDocument;
        },
        getAllSignersRequest: (state) => {
            state.signers.fetching = "loading";
        },
        getAllSignersSuccess: (state, action) => {
            state.signers.fetching = "success";
            state.signers.data = action.payload;
        },
        getAllSignersFailure: (state, action) => {
            state.signers.fetching = "failure";
            state.signers.error = action.payload;
        },
        postSignersRequest: (state) => {
            state.signers.post.fetching = "loading";
        },
        postSignersSuccess: (state, action) => {
            state.signers.post.fetching = "success";
            state.signers.post.data = action.payload;
            state.signers.count = state.signers.count + 1;
        },
        postSignersFailure: (state, action) => {
            state.signers.post.fetching = "failure";
            state.signers.post.error = action.payload;
        },
        putSignersRequest: (state) => {
            state.signers.put.fetching = "loading";
        },
        putSignersSuccess: (state, action) => {
            state.signers.put.fetching = "success";
            state.signers.put.data = action.payload;
            state.signers.count = state.signers.count + 1;
        },
        putSignersFailure: (state, action) => {
            state.signers.put.fetching = "failure";
            state.signers.put.error = action.payload;
        },
        cleanSigners: (state) => {
            state.signers.fetching = initialState.signers.fetching;
            state.signers.post.fetching = initialState.signers.post.fetching;
            state.signers.put.fetching = initialState.signers.put.fetching;
            state.signers.count = initialState.signers.count;
        },
        patchBankDataRequest: (state) => {
            state.signers.bankData.fetching = "loading";
        },
        patchBankDataSuccess: (state, action) => {
            state.signers.bankData.fetching = "success";
            state.signers.bankData.data = action.payload;
        },
        patchBankDataFailure: (state) => {
            state.signers.bankData.fetching = "failure";
        },
        cleanBankData: (state) => {
            state.signers.bankData.fetching = initialState.signers.bankData.fetching;
            state.signers.bankData.data = initialState.signers.bankData.data;
        },
        getIsValidDocumentsRequest: (state) => {
            state.valid.fetching = "loading";
        },
        getIsValidDocumentsSuccess: (state, action) => {
            state.valid.fetching = "success";
            state.valid.data = action.payload;
        },
        getIsValidDocumentsFailure: (state, action) => {
            state.valid.fetching = "failure";
            state.valid.error = action.payload;
        },
        cleanIsValidDocuments: (state) => {
            state.valid.fetching = initialState.valid.fetching;
        },
        getValidSignersDocumentsRequest: (state) => {
            state.valid.signers.fetching = "loading";
        },
        getValidSignersDocumentsSuccess: (state, action) => {
            state.valid.signers.fetching = "success";
            state.valid.signers.data = action.payload;
        },
        getValidSignersDocumentsFailure: (state, action) => {
            state.valid.signers.fetching = "failure";
            state.valid.signers.error = action.payload;
        },
        cleanValidSignersDocuments: (state) => {
            state.valid.signers.fetching = initialState.valid.signers.fetching;
        },
    },
});

export const {
    setDocuments,
    getDocumentsTypesRequest,
    getDocumentsTypesSuccess,
    getDocumentsTypesFailure,
    cleanGetDocumentsTypes,
    getDocumentsRequest,
    getDocumentsSuccess,
    getDocumentsFailure,
    cleanGetDocuments,
    postDocumentImageRequest,
    postDocumentImageSuccess,
    postDocumentImageFailure,
    cleanPostDocumentImage,
    postDocumentsRequest,
    postDocumentsSuccess,
    postDocumentsFailure,
    cleanPostDocuments,
    deleteDocumentImageRequest,
    deleteDocumentImageSuccess,
    deleteDocumentImageFailure,
    cleanDeleteDocumentImage,
    deleteDocumentRequest,
    deleteDocumentSuccess,
    deleteDocumentFailure,
    cleanDeleteDocument,
    getAllSignersRequest,
    getAllSignersSuccess,
    getAllSignersFailure,
    postSignersRequest,
    postSignersSuccess,
    postSignersFailure,
    putSignersRequest,
    putSignersSuccess,
    putSignersFailure,
    cleanSigners,
    patchBankDataRequest,
    patchBankDataSuccess,
    patchBankDataFailure,
    cleanBankData,
    getIsValidDocumentsRequest,
    getIsValidDocumentsSuccess,
    getIsValidDocumentsFailure,
    cleanIsValidDocuments,
    getValidSignersDocumentsRequest,
    getValidSignersDocumentsSuccess,
    getValidSignersDocumentsFailure,
    cleanValidSignersDocuments
} =
    documentsSlice.actions;

export default documentsSlice.reducer;
